module.exports = __webpack_public_path__ + "img/Calendar_Icon_Hover.d0520089.svg";